import { IStore } from "services/indexdb/interface/istore"

export const QueryStore: IStore = {
    Name: 'Query',
    PrimaryField: 'id',
    minimumVersion: 0
}
